import { useState, useContext } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import LockIcon from "@mui/icons-material/Lock";
import MainContext from "../../../context/mainContext";

function EndTrialAlert({ handleFullScreen }) {
  const { handlePageNumber } = useContext(MainContext);

  return (
    <Card>
      <Box
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? theme.palette.grey[200]
              : theme.palette.grey[700],
          mx: "auto",
          px: "auto",
        }}
      >
        <Box sx={{ textAlign: "center", color: "#ed4f4f", height: 35 }}>
          <LockIcon
            sx={{ textAlign: "center", height: "100%", width: "100%" }}
          />
        </Box>{" "}
      </Box>
      <CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "baseline",

          }}
        >
          <Typography
            // component="h5"
            // variant="h5"
            color="text.primary"
            sx={{ textAlign: "center" }}
          >
            <Typography sx={{ border: "1px #893d0d dashed", borderRadius: "10px", p: 1 }}>اتمام پکیج آزمایشی</Typography>
          </Typography>
        </Box>
      </CardContent>
      <CardActions >
        <Button
          onClick={() => { handlePageNumber("", 2); handleFullScreen.exit() }}
          variant="contained"
          className="yn-showPackages"
          fullWidth
          color="info"
        >
          دریافت پکیج ویژه
        </Button>
      </CardActions>
    </Card>
  );
}

export default EndTrialAlert;
